export default "__VITE_ASSET__DYY3BZoN__"